import type { FC } from '../../lib/teact/teact';
import React, { useEffect, useState } from '../../lib/teact/teact';

type AppInactiveComponent = typeof import('./AppInactive').default;

const AppInactiveAsync: FC = () => {
  const [AppInactive, setAppInactive] = useState<AppInactiveComponent | undefined>();

  useEffect(() => {
    let isMounted = true;

    void import(/* webpackChunkName: "AppInactive" */ './AppInactive').then(({ default: Component }) => {
      if (isMounted) {
        setAppInactive(() => Component);
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  return AppInactive ? <AppInactive /> : undefined;
};

export default AppInactiveAsync;
